import DocumentsRequest from '../ws/DocumentsRequest';

export const DOCUMENTS_UPDATE = 'documents-update';
export const DOCUMENTS_LOADING = 'documents-loading';
export const DOCUMENTS_ERROR = 'documents-error';

export const getDocuments = (
    id,
    page = 1,
    search = '',
    filter = 0,
    document_schema_type_id = null,
    query_ids = {},
    document_type_id = null,
    includeCriteria = {},
) => (dispatch) => {
    new DocumentsRequest(
        page,
        search,
        filter,
        document_schema_type_id,
        query_ids,
        document_type_id,
        false,
        null,
        null,
        false,
        includeCriteria,
    )
        .onPreExecution(() => {
            dispatch({ type: DOCUMENTS_LOADING, id: id, payload: true });
        })
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: DOCUMENTS_UPDATE,
                id: id,
                payload: response,
            });
        })
        .onFail(error => {
            dispatch({ type: DOCUMENTS_ERROR, id: id, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: DOCUMENTS_LOADING, id: id, payload: false });
        })
        .execute();
};



// WEBPACK FOOTER //
// ./src/app/documents/actions/documentsActions.js